export const DISPLAY_RULE_SCOPE = {
  ALWAYS: "always",
  GLOBAL: "global",
  ZONE: "zone",
  USER: "user",
  DATA: "data",
};

export const DISPLAY_RULE_GROUPS = [
  "dashboard",
  "sidebar",
  "header",
  "settings",
];

const RULES = [
  {
    id: "dashboard.volume",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "dashboard.sortingErrors",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.ZONE,
  },
  {
    id: "dashboard.rotations",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.ZONE,
  },
  {
    id: "dashboard.characterizations",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "dashboard.sites",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "dashboard.campaigns",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "dashboard.characterizationsInProgress",
    group: "dashboard",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "sidebar.dashboard",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "sidebar.monitoring",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "sidebar.characterization",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "sidebar.performance",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "sidebar.history",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "sidebar.campaign",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.GLOBAL,
  },
  {
    id: "sidebar.settings",
    group: "sidebar",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "header.access",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.USER,
  },
  {
    id: "header.notifications",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "header.confrontations",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "header.documents",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "header.api",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "header.help",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
  {
    id: "header.designSystem",
    group: "header",
    scope: DISPLAY_RULE_SCOPE.USER,
  },
  {
    id: "settings.hub",
    group: "settings",
    scope: DISPLAY_RULE_SCOPE.ALWAYS,
  },
];

const visibleWhen = (value) => Boolean(value);

const resolveRuleState = (id, context = {}) => {
  const {
    monitoringModuleOn = false,
    characterizationModuleOn = false,
    campaignModuleOn = false,
    activatedSortingErrorOption = false,
    showRotations = true,
    hasSites = false,
    isAdmin = false,
    userRole = null,
    showStorybookLink = false,
  } = context;

  const moduleVisible = (enabled) => enabled || isAdmin;
  const moduleLocked = (enabled) => isAdmin && !enabled;

  switch (id) {
    case "dashboard.sortingErrors":
      return { visible: visibleWhen(activatedSortingErrorOption) };
    case "dashboard.rotations":
      return { visible: visibleWhen(showRotations) };
    case "dashboard.characterizations":
    case "dashboard.characterizationsInProgress":
      return { visible: visibleWhen(characterizationModuleOn) };
    case "dashboard.volume":
      return { visible: visibleWhen(monitoringModuleOn) };
    case "dashboard.sites":
      return { visible: monitoringModuleOn && hasSites };
    case "dashboard.campaigns":
      return { visible: visibleWhen(campaignModuleOn) };
    case "sidebar.monitoring":
      return {
        visible: moduleVisible(monitoringModuleOn),
        locked: moduleLocked(monitoringModuleOn),
      };
    case "sidebar.characterization":
      return {
        visible: moduleVisible(characterizationModuleOn),
        locked: moduleLocked(characterizationModuleOn),
      };
    case "sidebar.campaign":
      return {
        visible: moduleVisible(campaignModuleOn),
        locked: moduleLocked(campaignModuleOn),
      };
    case "header.access":
      return { visible: userRole === "owner" };
    case "header.designSystem":
      return { visible: visibleWhen(showStorybookLink) };
    default:
      return { visible: true };
  }
};

export const getStoredUserRole = () => {
  try {
    const stored = JSON.parse(localStorage.getItem("user") || "null");
    return stored?.role ?? null;
  } catch {
    return null;
  }
};

export const evaluateDisplayRules = (context = {}) =>
  RULES.map((rule) => {
    const state = resolveRuleState(rule.id, context);
    return {
      ...rule,
      visible: Boolean(state.visible),
      locked: Boolean(state.locked),
    };
  });
